export default {
  countCells: 4,
  table_1: [
    {
      dataField: 'mmm',
      cols: 1,
      rows: 1,
      text: '',
      class: 'd-flex align-center',
      headerStyles: `border: 1px solid #b7ced9; min-width: 250px; background: unset`,
      variable: false,
      // template: (r) => r?.id
    },
    {
      dataField: 'mmm1',
      cols: 3,
      rows: 1,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; border-top: 1px solid #b7ced9; align-items: center; padding: 5px 10px; background: unset`,
      variable: false,
      text: `Число обучающихся по образовательным программа, реализуемым с использованием сетевой формы - всего`,
    },
    {
      dataField: 'bsm',
      cols: 1,
      rows: 1,
      text: 'Образовательные программы',
      class: 'd-flex align-center',
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; background: unset; padding-left: 5px`,
      styles: 'border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; padding-left: 10px',
      variable: true,
    },
    {
      dataField: 'qibcg20',
      cols: 1,
      rows: 1,
      text: 'в 2021/22 учебном году',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9; color: black',
      variable: true,
    },
    {
      dataField: 'qibcg21',
      cols: 1,
      rows: 1,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center; background: unset`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
      text: `в 2022/23 учебном году`,
    },
    {
      dataField: 'qibcg22',
      cols: 1,
      rows: 1,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center; background: unset`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
      text: `в 2023/24 учебном году`,
    },
  ],
  table_2: [
    {
      dataField: 'mmm',
      cols: 5,
      rows: 1,
      text: '',
      class: 'd-flex align-center',
      headerStyles: `border-right: 1px solid #b7ced9; background: unset; border-top: 1px solid #b7ced9; ; border-left: 1px solid #b7ced9;`,
      variable: false,
      // template: (r) => r?.id
    },
    {
      dataField: 'mmm1',
      cols: 6,
      rows: 1,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; align-items: center; padding: 5px 10px; background: unset; border-top: 1px solid #b7ced9;`,
      variable: false,
      text: `Обучающихся (искл. квоту иностр.граждан)`,
    },
    {
      dataField: 'mmm2',
      cols: 1,
      rows: 1,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; align-items: center; justify-content: center; background: unset; border-top: 1px solid #b7ced9;`,
      variable: false,
      styles: ``,
      text: `...`,
    },
    {
      dataField: 'mmm3',
      cols: 6,
      rows: 1,
      class: `justify-center`,
      headerStyles: `align-items: center;  padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9; border-top: 1px solid #b7ced9;`,
      styles: ``,
      variable: false,
      text: `Обучающихся - иностранных граждан`,
    },
    {
      dataField: 'column_1_2',
      cols: 5,
      rows: 1,
      text: 'Уровни и формы образования',
      class: 'd-flex align-center',
      headerStyles: `border-right: 1px solid #b7ced9;  padding: 5px 10px; background: unset; border-left: 1px solid #b7ced9;`,
      styles: 'border-right: 1px solid #b7ced9',
      variable: false,
      // template: (r) => r?.id
    },
    {
      dataField: 'column_3',
      cols: 2,
      rows: 1,
      text: 'в 2021/22 учебном году',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9',
      variable: false,
    },
    {
      dataField: 'column_4',
      cols: 2,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `в 2022/23 учебном году`,
    },
    {
      dataField: 'column_5',
      cols: 2,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `в 2023/24 учебном году`,
    },
    {
      dataField: 'column_6',
      cols: 1,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset `,
      styles: 'border-right: 1px solid #b7ced9',
      text: `...`,
    },
    {
      dataField: 'column_7',
      cols: 2,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `в 2021/22 учебном году`,
    },
    {
      dataField: 'column_8',
      cols: 2,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
      text: `в 2022/23 учебном году`,
    },
    {
      dataField: 'column_9',
      cols: 2,
      rows: 1,
      variable: false,
      class: `justify-center`,
      headerStyles: `justify-content: center;   padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9;`,
      styles: '',
      text: `в 2023/24 учебном году`,
    },
    {
      dataField: 'bsm',
      cols: 2,
      rows: 1,
      text: '1',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; color: black',
      variable: true,
    },
    {
      dataField: 'fo',
      cols: 3,
      rows: 1,
      text: '2',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
      variable: true,
    },
    {
      dataField: 'nb20',
      cols: 2,
      rows: 1,
      text: '3',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9; color: black',
      variable: true,
    },
    {
      dataField: 'nb21',
      cols: 2,
      rows: 1,
      text: `4`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
    },
    {
      dataField: 'nb22',
      cols: 2,
      rows: 1,
      variable: true,
      text: `5`,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
    },
    {
      dataField: 'xxx',
      cols: 1,
      rows: 1,
      text: `...`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center; background: unset`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
    },
    {
      dataField: 'nq20',
      cols: 2,
      rows: 1,
      text: `7`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
    },
    {
      dataField: 'nq21',
      cols: 2,
      rows: 1,
      variable: true,
      text: `8`,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
    },
    {
      dataField: 'nq22',
      cols: 2,
      rows: 1,
      variable: true,
      text: `9`,
      class: `justify-center`,
      headerStyles: `justify-content: center;  padding: 5px 10px; background: unset; border-right: 1px solid #b7ced9;`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
    },
  ],
  table_3: [
    {
      dataField: 'mmm',
      cols: 3,
      rows: 1,
      text: 'Всего обучающихся',
      class: 'd-flex align-center',
      headerStyles: `background: unset`,
      variable: false,
    },
    {
      dataField: 'column_1',
      cols: 1,
      rows: 1,
      text: 'на 01.10.2021 г.',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9',
      variable: false,
    },
    {
      dataField: 'column_2',
      cols: 1,
      rows: 1,
      text: `на 01.10.2022 г.`,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
    },
    {
      dataField: 'column_3',
      cols: 1,
      rows: 1,
      text: `на 01.10.2023 г.`,
      variable: false,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9',
    },
    {
      dataField: 'no20',
      cols: 1,
      rows: 1,
      text: 'гр.3 + гр.7',
      class: `justify-center p-0`,
      headerStyles: `border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'justify-content: unset; border-right: 1px solid #b7ced9; border-left: 1px solid #b7ced9; color: black',
      variable: true,
    },
    {
      dataField: 'no21',
      cols: 1,
      rows: 1,
      text: `гр.4 + гр.8`,
      variable: true,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
    },
    {
      dataField: 'no22',
      cols: 1,
      rows: 1,
      variable: true,
      text: `гр.5 + гр.9`,
      class: `justify-center`,
      headerStyles: `border-right: 1px solid #b7ced9; justify-content: center;  padding: 5px 10px; background: unset`,
      styles: 'border-right: 1px solid #b7ced9; color: black',
    },
  ]
}